import CommonFriendStructure from "../Constants/FriendDataStructure"; // Import structure

export const fetchFeedDataForFriends = async () => {
  try {
    const response = await fetch("/api/mock/Friend/apiFriendMockData.json"); // Fetch from public folder
    const data = await response.json();

    // Ensure data follows CommonFriendStructure
    const formattedData = {
      accUserId: data.accUserId || "",
      friendList: (data.friendList || []).map((friend) => ({
          friendid: friend.friendid || "",
          friendProfpic: friend.friendProfpic || "",
          createdOn: friend.createdOn || "",
          location: friend.location || "",
          dateofbirth: friend.dateofbirth || "",
          activelevel: friend.activelevel || "",
          gender: friend.gender || "",
        })),
    };
    return formattedData;
  } catch (error) {
    console.error("Error fetching friend feed data:", error);
    return { accUserId: "", friendList: [] };
  }
};
